import React from "react";
import { Box, Link } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import global_payments_logo from "@assets/global_payments_logo.png";
import global_payments_logo_2x from "@assets/global_payments_logo@2x.png";

const useStyles = makeStyles({
  logo: {
    display: "block",
  },
});

export const Logo: React.FC = () => {
  const classNames = useStyles();

  return (
    <Box
      height={20}
      flexGrow={1}
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
    >
      <Link href="https://www.globalpaymentsinc.com/">
        <img
          src={global_payments_logo}
          srcSet={`${global_payments_logo} 1x, ${global_payments_logo_2x} 2x`}
          alt="Global Payments"
          className={classNames.logo}
        />
      </Link>
    </Box>
  );
};
